var React = require('react');

function ScrollToTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 32.505a14.505 14.505 0 10-13.403-8.953A14.497 14.497 0 0018 32.505zM18 0a18 18 0 110 36 18 18 0 010-36zm-7.637 22.897l-2.805-2.82 10.53-10.48 10.53 10.48-2.806 2.82-7.724-7.688-7.725 7.688z","fill":"currentColor"}));
}

ScrollToTop.defaultProps = {"viewBox":"0 0 36 36","fill":"none"};

module.exports = ScrollToTop;

ScrollToTop.default = ScrollToTop;
